import { PopoverInteractionKind, PopoverProps } from "@blueprintjs/core";
import React, { useCallback } from "react";

import { HexPopover } from "../../../hex-components/HexPopover.js";

export interface ProjectCardPopoverProps {
  children: JSX.Element;
  disabled?: boolean;
  interactionKind?: PopoverProps["interactionKind"];
  onClosed?: PopoverProps["onClosed"];
  onOpened?: PopoverProps["onOpened"];
  popoverContent: PopoverProps["content"];
  hoverCloseDelay?: PopoverProps["hoverCloseDelay"];
}

export const ProjectCardPopover: React.ComponentType<
  ProjectCardPopoverProps
> = ({
  children,
  disabled,
  hoverCloseDelay = 200,
  interactionKind = PopoverInteractionKind.HOVER_TARGET_ONLY,
  onClosed,
  onOpened,
  popoverContent,
}) => {
  const renderTarget = useCallback(
    ({ isOpen: _isOpen, onClick, ref, ...props }: any) => {
      const handleClick: React.MouseEventHandler = (e) => {
        e.stopPropagation();

        onClick?.(e);
      };
      const clone = React.cloneElement(children, {
        ...props,
        onClick: handleClick,
        ref,
      });

      return clone;
    },
    [children],
  );
  return (
    <HexPopover
      content={popoverContent}
      disabled={disabled}
      hoverCloseDelay={hoverCloseDelay}
      interactionKind={interactionKind}
      minimal={true}
      placement="bottom"
      renderTarget={renderTarget}
      onClosed={onClosed}
      onOpened={onOpened}
    ></HexPopover>
  );
};
